import React, { useState, useEffect } from "react";
import PropertiesService from "../../../Services/PropertiesService";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../Constant/Notification";
import { MdAddCircleOutline } from "react-icons/md";
import { FiEdit } from "react-icons/fi";
import ApartmentUnitForm from "./ApartmentUnitForm";
import { plotStatusIds, roadFacingSides } from "../../../../Enum";
import { userUid } from "../../../Constant/Constant";
import { IoDocumentLockOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { RiFileInfoLine } from "react-icons/ri";
import BulkUploadModel from "../BulkUploadModel";
import * as XLSX from "xlsx";
import ApartmentBulkModel from "./ApartmentBulkModel";
import { FaRegEye } from "react-icons/fa";
import { formatINR, formatINRShort } from "../../../../utils/formatINR";
const ApartmentUnitTable = ({
  towers,
  propertyId,
  totalUnitsPerTower,
  selectedTowerId,
  onTotalUnitsChange,
  onAdd,
  onEdit,
  handleSetLoading,
  setShowBulkModal,
  showBulkModal,
  isEdit,
  lastUnitTrigger = false,
  setTotalRowUnits,
}) => {
  const [selectedTower, setSelectedTower] = useState(towers[0]?.id || "");
  const [uploadedTowers, setUploadedTowers] = useState([]);
  const [selectedTowerValue, setSelectedTowerValue] = useState(
    towers[0]
      ? {
          value: towers[0].id,
          label: towers[0].towerName || `Tower ${towers[0].towerNum}`,
        }
      : null
  );
  const [currentTowerIndex, setCurrentTowerIndex] = useState(0);
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [editingUnit, setEditingUnit] = useState(null);
  const [isNewUnit, setIsNewUnit] = useState(false);
  const [localUnits, setLocalUnits] = useState([]);
  const [exitingTotalUnits, setExitingTotalUnits] = useState(0);
  const [totalUnits, setTotalUnits] = useState(
    totalUnitsPerTower[towers[0]?.towerNum] || 0
  );
  const [loading, setLoading] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);
  const [showValidationModal, setShowValidationModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const navigate = useNavigate();
  const [totalunitFloors, setTotalUnitFloors] = useState(
    towers[0]?.totalFloors || 0
  );

  const [insertedCount, setInsertedCount] = useState(0);

  const [towerUploadStatus, setTowerUploadStatus] = useState({});

  const getFloorOptions = () => {
    const options = [];
    for (let i = 1; i <= totalunitFloors; i++) {
      options.push({ value: i, label: `Floor ${i}` });
    }
    return options;
  };

  const getIdByLabel = (items, label) => {
    const item = items.find((i) => i.label === label);
    return item ? item.id : "";
  };

  useEffect(() => {
    setTotalUnits(totalUnitsPerTower[towers[0]?.towerNum] || 0);
    if (selectedTower) {
      selectedTowerId(selectedTower);
      fetchUnitsForTower(selectedTower);
      const tower = towers.find((t) => t.id === selectedTower);
      setTotalUnits(0);
    }
  }, [selectedTower]);

  useEffect(() => {
    if (localUnits?.length > 0) {
      setTotalUnits(localUnits?.length);
    }
  }, [totalUnitsPerTower, towers]);

  useEffect(() => {
    if (lastUnitTrigger && hasChanges) {
      saveUnitsForTower(selectedTower);
    }
  }, [lastUnitTrigger]);

  const fetchUnitsForTower = async (towerId) => {
    setLoading(true);
    try {
      const unitsResponse =
        await PropertiesService.getApartmentUnitsByPropertyId(
          propertyId,
          towerId
        );
      const unitsData = unitsResponse.data?.units || [];

      setTotalRowUnits(unitsData?.length);
      const mappedUnits = unitsData.map((unit, index) => ({
        ...unit,
        order: index + 1,
        floors: unit.unitFloor || 0,
        towerId: towerId,
        towerNum: towers.find((t) => t.id === towerId)?.towerNum || 1,
        isArchived: false,
      }));

      if (unitsData.length > 0) {
        setUploadedTowers((prev) => [...new Set([...prev, towerId])]);
      }

      setLocalUnits(mappedUnits);
      setExitingTotalUnits(unitsData?.length);

      const totalFloors =
        unitsResponse.data?.totalFloors ||
        towers.find((t) => t.id === towerId)?.totalFloors ||
        0;
      setTotalUnitFloors(totalFloors);

      const tower = towers.find((t) => t.id === towerId);
      if (tower) {
        onTotalUnitsChange(
          tower.towerNum,
          mappedUnits.filter((u) => !u.isArchived).length
        );
      }
      setHasChanges(false);
    } catch (error) {
      console.error("Error fetching units:", error);
    } finally {
      setLoading(false);
    }
  };

  const saveUnitsForTower = async (towerId) => {
    handleSetLoading(true);
    setLoading(true);
    try {
      const validUnits = localUnits.filter(
        (unit) =>
          unit &&
          unit.unitNo?.trim() &&
          unit.buildUpArea > 0 &&
          !unit.isArchived
      );

      if (validUnits.length === 0 && localUnits.some((unit) => unit !== null)) {
        showErrorToast(
          "All units must have a valid unit number and build-up area!"
        );
        return;
      }

      const updatedUnits = validUnits.map((unit, index) => ({
        ...unit,
        order: index + 1,
      }));

      const newUnits = updatedUnits.filter(
        (unit) => !unit.id || unit.id.startsWith("temp-")
      );
      const existingUnits = updatedUnits.filter(
        (unit) => unit.id && !unit.id.startsWith("temp-") && unit.isModified
      );

      const formatUnit = (unit, isExisting) => ({
        ...(isExisting
          ? { docId: unit.id, modifiedBy: userUid }
          : { createdBy: userUid }),
        unitNo: unit.unitNo || "",
        order: unit.order,
        carpetArea: Number(unit.carpetArea) || 0,
        baseRate: Number(unit.baseRate) || 0,
        saleableArea: Number(unit.saleableArea) || 0,
        basePrice: Number(unit.baseRate) * Number(unit.saleableArea) || 0,
        allInclusiveCharges: Number(unit.allInclusiveCharges) || 0,
        buildUpArea: Number(unit.buildUpArea) || 0,
        terraceArea: Number(unit.terraceArea) || 0,
        guidelineSqftPrice: Number(unit.guidelineSqftPrice) || 0,
        totalBhk: Number(unit.totalBhk) || 0,
        notes: unit.notes || "",
        bathrooms: Number(unit.bathrooms) || "",
        unitFloor: Number(unit.floors) || 0,
        registrationCharge: Number(unit.registrationCharge) || 0,
        furnished: unit.furnished || "",
        furnishedCharge:
          unit.furnished === "Unfurnished"
            ? 0
            : Number(unit?.furnishedCharge) || 0,
        electricityCharge: Number(unit?.electricityCharge) || 0,
        preferredLocationCharge: Number(unit?.preferredLocationCharge) || 0,
        roadFacingSideId: unit.roadFacingSide?.id || "",
        parking: unit.parking || "",
        coveredParking: unit.coveredParking || "",
        lift: unit.lift || "",
        balconyDirection: unit.balconyDirection || "",
        balconyView: unit.balconyView || "",
        unitStatusId: unit.unitStatus?.id || "",
        propertyId: propertyId,
        uds: Number(unit.uds) || "",
        towerId: towerId,
        unitFloor: Number(unit.floors) || 0,
      });

      if (newUnits.length > 0) {
        const createPayload = {
          docId: propertyId,
          units: newUnits.map((unit) => formatUnit(unit, false)),
        };
        await PropertiesService.createApartmentUnit(createPayload);
      }

      if (existingUnits.length > 0) {
        const updatePayload = {
          docId: propertyId,
          units: existingUnits.map((unit) => formatUnit(unit, true)),
        };
        await PropertiesService.updateApartmentUnit(updatePayload);
      }

      if (newUnits.length > 0 || existingUnits.length > 0) {
        showSuccessToast("Units saved successfully!");
        setHasChanges(false);
      }
    } catch (error) {
      console.error("Error saving units:", error);
    } finally {
      setLoading(false);
      handleSetLoading(false);
    }
  };

  const handleTabChange = async (tower) => {
    if (hasChanges) {
      await saveUnitsForTower(selectedTower);
    }
    setTotalUnitFloors(tower?.totalFloors || 0);
    setSelectedTower(tower?.id);
    setSelectedTowerValue({
      value: tower.id,
      label: tower.towerName || `Tower ${tower.towerNum}`,
    });
    setCurrentTowerIndex(towers.findIndex((t) => t.id === tower.id));
    setEditingUnit(null);
    setIsSliderOpen(false);
  };

  const handleNextTower = () => {
    if (currentTowerIndex < towers.length - 1) {
      const nextIndex = currentTowerIndex + 1;
      const nextTower = towers[nextIndex];
      setSelectedTower(nextTower.id);
      setSelectedTowerValue({
        value: nextTower.id,
        label: nextTower.towerName || `Tower ${nextTower.towerNum}`,
      });
      setCurrentTowerIndex(nextIndex);
      setTotalUnitFloors(nextTower?.totalFloors || 0);
      fetchUnitsForTower(nextTower.id);
    }
  };

  const handleDone = () => {
    setShowBulkModal(false);
    setSelectedFile(null);
    setCurrentTowerIndex(0);
    setSelectedTower(towers[0]?.id || "");
    setSelectedTowerValue(
      towers[0]
        ? {
            value: towers[0].id,
            label: towers[0].towerName || `Tower ${towers[0].towerNum}`,
          }
        : null
    );
    setUploadedTowers([]);
    fetchUnitsForTower(towers[0]?.id || "");
    navigate(-1);
  };

  const handleTotalUnitsChange = (e) => {
    const newValue = Number(e.target.value) || 0;
    setTotalUnits(newValue);
    setTotalRowUnits(newValue);
    const tower = towers.find((t) => t.id === selectedTower);
    if (tower) {
      onTotalUnitsChange(tower.towerNum, newValue);
    }
  };

  const handleBulkUploadAppartUnits = async (file, towerId) => {
    if (!file || !(file instanceof Blob)) {
      showErrorToast("Invalid file format or no file selected.");
      return;
    }

    if (!towerId) {
      showErrorToast("Please select a tower before uploading units.");
      return;
    }

    const reader = new FileReader();

    reader.onload = async (e) => {
      setLoading(true);
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];

        const rawData = XLSX.utils.sheet_to_json(sheet, { defval: "" });

        const jsonData = rawData.map((row) => {
          const cleanedRow = {};
          Object.entries(row).forEach(([key, value]) => {
            const trimmedKey = key.trim().replace(/\s+/g, " ");
            cleanedRow[trimmedKey] = value;
          });
          return cleanedRow;
        });

        if (!jsonData.length) {
          showErrorToast("Uploaded Excel is empty.");
          return;
        }

        if (jsonData.length > 200) {
          setValidationErrors(["Only 200 rows are allowed."]);
          setShowValidationModal(true);
          return;
        }

        const seenUnits = new Set();
        const errors = [];

        const formattedUnits = jsonData.map((row, index) => {
          const rowNum = index + 2;
          const unitNo = row["Unit Number"]?.toString().trim() || "";

          if (!unitNo) {
            errors.push(`Row ${rowNum}: Unit Number is required.`);
          } else if (seenUnits.has(unitNo)) {
            errors.push(`Row ${rowNum}: Duplicate Unit Number "${unitNo}"`);
          } else {
            seenUnits.add(unitNo);
          }

          const requiredFields = [
            "Saleable Area",
            "Build-Up Area",
            "Unit Floors",
            "Total BHK",
            "Base Rate",
            "Status",
            "Unit Facing Side",
          ];

          requiredFields.forEach((field) => {
            if (
              row[field] === undefined ||
              row[field] === null ||
              row[field].toString().trim() === ""
            ) {
              errors.push(`Row ${rowNum}: ${field} is required.`);
            }
          });

          return {
            unitNo,
            order: index + 1,
            saleableArea: Number(row["Saleable Area"]) || 0,
            buildUpArea: Number(row["Build-Up Area"]) || 0,
            unitFloor: Number(row["Unit Floors"]) || 0,
            totalBhk: Number(row["Total BHK"]) || 0,
            baseRate: Number(row["Base Rate"]) || 0,
            basePrice:
              Number(row["Base Rate"]) * Number(row["Saleable Area"]) || 0,
            unitStatusId: getIdByLabel(plotStatusIds, row["Status"]),
            roadFacingSideId: getIdByLabel(
              roadFacingSides,
              row["Unit Facing Side"]?.trim() || ""
            ),

            guidelineSqftPrice: Number(row["Guideline SQ. FT Price"]) || 0,
            registrationCharge: Number(row["Registration Charge"]) || 0,
            allInclusiveCharges: Number(row["All Inclusive Charges"]) || 0,
            electricityCharge: Number(row["Electricity Charge"]) || 0,
            furnished: row["Furnished"] || "",
            furnishedCharge: Number(row["Furnished Charge"]) || 0,
            carpetArea: Number(row["Carpet Area"]) || 0,
            terraceArea: Number(row["Terrace Area"]) || 0,
            bathrooms: Number(row["Bathrooms"]) || 0,
            parking: row["Parking"] || "",
            coveredParking: row["Covered Parking"] || "",
            lift: row["Lift"] || "",
            swimmingPool: row["Swimming Pool"] || "",
            villaViewType: row["Villa View Type"] || "",
            notes: row["Notes"] || "",
            preferredLocationCharge:
              Number(row["Preferred Location Charge"]) || 0,
            createdBy: userUid,
            towerId: towerId,
            propertyId: propertyId,
            uds: Number(row["UDS"]) || 0,
          };
        });

        if (errors.length > 0) {
          setValidationErrors(errors);
          setShowValidationModal(true);
          return;
        }

        const payload = {
          docId: propertyId,
          units: formattedUnits,
        };

        console.log("payload ", payload);

        const response = await PropertiesService.createApartmentUnit(payload);
        if (response) {
          console.log(response);

          showSuccessToast(response?.data?.message);
          setTowerUploadStatus((prev) => ({
            ...prev,
            [towerId]: {
              insertedCount: response.data?.insertedCount || 0,
              skippedCount: response.data?.skippedCount || 0,
              skippedUnitNos: response.data?.skippedUnitNos || [],
            },
          }));

          setSelectedFile(null);
        }

        setUploadedTowers((prev) => [...prev, towerId]);

        const maxFloors = Math.max(
          ...formattedUnits.map((unit) => unit.floors),
          0
        );
        if (maxFloors > 0) {
          const tower = towers.find((t) => t.id === towerId);
          if (tower && maxFloors !== tower.totalFloors) {
            await PropertiesService.updateTower({
              docId: propertyId,
              towerId: towerId,
              totalFloors: maxFloors,
              modifiedBy: userUid,
            });
          }
        }

        await fetchUnitsForTower(towerId);

        // showSuccessToast("Apartment units uploaded successfully!");
      } catch (err) {
        console.error("Bulk upload apartment units error:", err);
      } finally {
        setLoading(false);
      }
    };

    reader.readAsArrayBuffer(file);
  };

  const handleAddUnit = () => {
    const defaultStatus = plotStatusIds.find(
      (status) => status.label === "Available"
    );
    const tower = towers.find((t) => t.id === selectedTower);
    const currentUnitCount = localUnits.filter(
      (u) => u && !u.isArchived
    ).length;

    const newUnit = {
      id: `temp-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      order: currentUnitCount + 1,
      unitNo: "",
      carpetArea: 0,
      buildUpArea: 0,
      terraceArea: 0,
      saleableArea: 0,
      guidelineSqftPrice: 0,
      floors: 1,
      totalBhk: 0,
      basePrice: 0,
      baseRate: 0,
      allInclusiveCharges: 0,
      bathrooms: "",
      roadFacingSide: { id: "", name: "N/A" },
      registrationCharge: 0,
      furnished: "",
      furnishedCharge: 0,
      electricityCharge: 0,
      preferredLocationCharge: 0,
      uds: 0,
      parking: "",
      coveredParking: "",
      lift: "",
      balconyDirection: "",
      balconyView: "",
      statusName: defaultStatus.label,
      notes: "",
      unitStatus: defaultStatus
        ? { id: defaultStatus.id, name: defaultStatus.label }
        : { id: "", name: "N/A" },
      createdBy: userUid,
      towerId: selectedTower,
      towerNum: tower?.towerNum || 1,
    };

    if (exitingTotalUnits > 0) {
      setTotalUnits(localUnits.length + 1);
    }

    setEditingUnit(newUnit);
    setIsNewUnit(true);
    setIsSliderOpen(true);
    onAdd(newUnit);
  };

  const handleEditUnit = (unit) => {
    setEditingUnit({
      ...unit,
      statusName: unit.unitStatus?.name || "",
    });
    setIsNewUnit(false);
    setIsSliderOpen(true);
    onEdit(unit);
  };

  const handleUnitFormChange = (e) => {
    const { name, value } = e.target;

    setEditingUnit((prev) => {
      if (name === "unitStatus") {
        const selectedStatus = plotStatusIds.find(
          (status) => status.id === value
        );
        return {
          ...prev,
          unitStatus: {
            id: value,
            name: selectedStatus ? selectedStatus.label : "",
          },
        };
      }

      if (name === "roadFacingSide") {
        const selectedSide = roadFacingSides.find((side) => side.id === value);
        return {
          ...prev,
          roadFacingSide: {
            id: value,
            name: selectedSide ? selectedSide.label : "",
          },
        };
      }

      if (name === "floors") {
        const floorValue = Number(value);
        if (floorValue > totalunitFloors) {
          showErrorToast(
            `Floor cannot exceed ${totalunitFloors} (total floors in this tower)`
          );
          return prev;
        }
      }

      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const handleFloorsChange = (e) => {
    const floors = Number(e.target.value);

    if (floors > totalunitFloors) {
      showErrorToast(
        `Floor cannot exceed ${totalunitFloors} (total floors in this tower)`
      );
      return;
    }

    setEditingUnit((prev) => {
      const newFloorsBhk = Array(floors)
        .fill()
        .map((_, i) => ({
          floor: i + 1,
          bhk: prev.floorsBhk?.[i]?.bhk || 0,
        }));
      const totalBhk = newFloorsBhk.reduce(
        (sum, item) => sum + Number(item.bhk),
        0
      );
      return {
        ...prev,
        floors,
        totalBhk,
      };
    });
  };

  const handleFloorBhkChange = (index, value) => {
    setEditingUnit((prev) => {
      const newFloorsBhk = [...prev.floorsBhk];
      newFloorsBhk[index] = { ...newFloorsBhk[index], bhk: Number(value) };
      const totalBhk = newFloorsBhk.reduce(
        (sum, item) => sum + Number(item.bhk),
        0
      );
      return {
        ...prev,
        floorsBhk: newFloorsBhk,
        totalBhk,
      };
    });
  };

  const handleApplyToAllUnits = () => {
    const fieldsToApply = {
      guidelineSqftPrice: editingUnit.guidelineSqftPrice,
      registrationCharge: editingUnit.registrationCharge,
      furnished: editingUnit.furnished,
      parking: editingUnit.parking,
      coveredParking: editingUnit.coveredParking,
      lift: editingUnit.lift,
      swimmingPool: editingUnit.swimmingPool,
      villaViewType: editingUnit.villaViewType,
    };

    setLocalUnits((prevUnits) =>
      prevUnits.map((unit, index) =>
        unit
          ? {
              ...unit,
              ...fieldsToApply,
              isModified: true,
              order: index + 1,
            }
          : null
      )
    );

    setHasChanges(true);
    showSuccessToast("Applied settings to all units!");
    setIsSliderOpen(false);
    setEditingUnit(null);
  };

  const handleSaveUnit = async () => {
    if (!editingUnit.unitNo.trim()) {
      showErrorToast("Unit number is required!");
      return;
    }
    if (
      localUnits.some(
        (unit) =>
          unit &&
          unit.unitNo === editingUnit.unitNo &&
          unit.id !== editingUnit.id
      )
    ) {
      showErrorToast("Unit number already exists!");
      return;
    }
    if (editingUnit.unitNo.length > 5) {
      showErrorToast("Unit number cannot exceed 5 characters!");
      return;
    }
    if (!editingUnit.buildUpArea || editingUnit.buildUpArea <= 0) {
      showErrorToast("Build-Up Area must be greater than 0!");
      return;
    }
    // if (editingUnit.buildUpArea < editingUnit.carpetArea) {
    //   showErrorToast("Build-Up Area cannot be less than Carpet Area!");
    //   return;
    // }
    // if (editingUnit.saleableArea < editingUnit.buildUpArea) {
    //   showErrorToast("Saleable Area should be greater than Build-Up Area!");
    //   return;
    // }
    if (!editingUnit.saleableArea || editingUnit.saleableArea <= 0) {
      showErrorToast("Saleable Area must be greater than 0!");
      return;
    }
    if (editingUnit.floors < 1 || editingUnit.floors > totalunitFloors) {
      showErrorToast(`Unit floor must be between 1 and ${totalunitFloors}!`);
      return;
    }
    if (editingUnit.totalBhk <= 0 || editingUnit.totalBhk > 10) {
      showErrorToast("Total BHK must be between 1 and 10!");
      return;
    }
    if (!editingUnit.baseRate || editingUnit.baseRate <= 0) {
      showErrorToast("Base Rate must be greater than 0!");
      return;
    }
    if (!editingUnit.uds || editingUnit.uds <= 0) {
      showErrorToast("UDS must be greater than 0!");
      return;
    }
    if (!editingUnit.roadFacingSide?.id) {
      showErrorToast("Road facing side is required!");
      return;
    }

    try {
      const unitToSave = {
        ...editingUnit,
        propertyId: propertyId,
        createdBy: userUid,
        modifiedBy: userUid,
      };

      if (isNewUnit) {
        setLocalUnits((prevUnits) => {
          const newUnits = [...prevUnits];
          const orderIndex = editingUnit.order - 1;
          const newUnit = {
            ...unitToSave,
            id: unitToSave.id,
            isNew: true,
          };

          while (orderIndex >= newUnits.length) {
            newUnits.push(null);
          }

          newUnits[orderIndex] = newUnit;

          return newUnits;
        });
      } else {
        setLocalUnits((prevUnits) => {
          const updatedUnits = prevUnits.map((unit) =>
            unit && unit.id === editingUnit.id
              ? { ...unitToSave, isModified: true }
              : unit
          );
          return updatedUnits;
        });
      }

      setHasChanges(true);
      setIsSliderOpen(false);
      setEditingUnit(null);
    } catch (error) {
      console.error("Error saving unit:", error);
      showErrorToast("Failed to save unit!");
    }
  };

  const handleCancelUnitEdit = () => {
    setIsSliderOpen(false);
    setEditingUnit(null);
  };

  const getStatusStyles = (status) => {
    switch (status) {
      case "Available":
        return "border-[#399E79] border bg-green-50 text-green-800";
      case "Agreement":
        return "border-[#FFDF94] border bg-yellow-50 text-yellow-800";
      case "Booked":
        return "border-[#EE6C4D] border bg-red-50 text-red-800";
      default:
        return "border-[#2280FF] border bg-blue-50 text-blue-800";
    }
  };

  const activeTower =
    towers.find((t) => t.id === selectedTower) || towers[0] || {};

  const tableRows =
    isSliderOpen && !isNewUnit
      ? localUnits
          .filter((unit) => unit && !unit.isArchived && !unit.isPlaceholder)
          .map((unit) => ({
            ...unit,
          }))
      : Array.from({ length: totalUnits }, (_, index) => {
          const unit = localUnits.find(
            (u) => u && u.order === index + 1 && !u.isArchived
          );
          return (
            unit || {
              id: `placeholder-${index}`,
              order: index + 1,
              unitNo: `Unit ${index + 1}`,
              saleableArea: 0,
              buildUpArea: 0,
              floors: 0,
              totalBhk: 0,
              baseRate: 0,
              basePrice: 0,
              unitStatus: { id: "", name: "N/A" },
              isPlaceholder: true,
            }
          );
        });

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm">
      {/* Tower Tabs */}
      <div className="flex flex-wrap items-center justify-between mb-6">
        <ul className="flex flex-wrap text-sm font-medium text-center text-gray-500">
          {towers.map((tower) => (
            <div key={tower.id} className="me-2">
              <button
                onClick={() => handleTabChange(tower)}
                className={`px-4 py-3 rounded-lg transition-all duration-200 flex items-center justify-center gap-2 ${
                  selectedTower === tower.id
                    ? "bg-white text-customGreen shadow-[0_4px_6px_0_rgba(0,0,0,0.1),0_-4px_6px_0_rgba(0,0,0,0.1),-4px_0_6px_0_rgba(0,0,0,0.1),4px_0_6px_0_rgba(0,0,0,0.1)]"
                    : "hover:text-gray-900 hover:bg-gray-100 border"
                } ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
                disabled={loading}
              >
                {tower.towerName || `Tower ${tower.towerNum}`}
                <small className="text-xs opacity-75">
                  ({tower.totalFloors} floors)
                </small>
              </button>
            </div>
          ))}
        </ul>

        <div className="flex items-center gap-3">
          {isEdit ? (
            <div className="flex items-center gap-3 p-2 bg-white rounded-md border-2 border-slate-200">
              <label className="flex items-center text-sm font-medium text-gray-700 whitespace-nowrap">
                <span className="inline-block w-1.5 h-4 bg-red-400 rounded-sm mr-2"></span>
                Units in{" "}
                {activeTower.towerName || `Tower ${activeTower.towerNum}`}
              </label>
              <input
                type="number"
                min={localUnits.filter((u) => u && !u.isArchived).length}
                value={totalUnits !== 0 ? totalUnits : ""}
                disabled={localUnits?.length > 0 ? true : false}
                onChange={handleTotalUnitsChange}
                placeholder="Units No"
                onWheel={(e) => e.target.blur()}
                className="w-24 px-3 py-2 border border-gray-300 rounded-md text-sm input-focus transition duration-150 ease-in-out no-arrow"
              />
            </div>
          ) : (
            <div className="flex items-center gap-3 p-2 bg-white rounded-md border-2 border-slate-200">
              <label className="flex items-center text-sm font-medium text-gray-700 whitespace-nowrap">
                <span className="inline-block w-1.5 h-4 bg-red-400 rounded-sm mr-2"></span>
                Units in{" "}
                {activeTower.towerName || `Tower ${activeTower.towerNum}`}
              </label>
              <input
                type="number"
                min={localUnits.filter((u) => u && !u.isArchived).length}
                value={totalUnits !== 0 ? totalUnits : ""}
                onChange={handleTotalUnitsChange}
                placeholder="Units No"
                onWheel={(e) => e.target.blur()}
                className="w-24 px-3 py-2 border border-gray-300 rounded-md text-sm input-focus transition duration-150 ease-in-out no-arrow"
              />
            </div>
          )}
          {/* <button
            onClick={() => setShowBulkModal(true)}
            className="px-4 py-2 bg-customGreen text-white rounded-md transition-colors flex items-center"
          >
            Bulk Upload
          </button> */}
        </div>
      </div>

      {/* Unit Table */}
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-gray-100 text-base text-center rounded-md">
              <th className="px-4 py-3 text-gray-700 font-medium">Unit No.</th>
              <th className="px-4 py-3 text-gray-700 font-medium">
                Saleable Area
              </th>
              <th className="px-4 py-3 text-gray-700 font-medium">
                Build-Up Area
              </th>
              <th className="px-4 py-3 text-gray-700 font-medium">
                Unit Floors
              </th>
              <th className="px-4 py-3 text-gray-700 font-medium">BHK</th>
              <th className="px-4 py-3 text-gray-700 font-medium">Base Rate</th>
              <th className="px-4 py-3 text-gray-700 font-medium">
                Base Price
              </th>
              <th className="px-4 py-3 text-gray-700 font-medium">Status</th>
              <th className="px-4 py-3 text-gray-700 font-medium">Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr className="text-center">
                <td colSpan={9} className="py-8 text-gray-500">
                  Loading...
                </td>
              </tr>
            ) : tableRows.length > 0 ? (
              tableRows.map((row) => (
                <tr
                  key={row.id}
                  className="border-b text-center border-gray-200 hover:bg-gray-50"
                >
                  <td className="px-4 text-sm py-4">{row.unitNo}</td>
                  <td className="px-4 py-4 text-sm">{row.saleableArea}</td>
                  <td className="px-4 py-4 text-sm">{row.buildUpArea}</td>
                  <td className="px-4 py-4 text-sm">
                    {row.floors > 0 ? ` ${row.floors}` : row.floors}
                  </td>
                  <td className="px-4 py-4 text-sm">{row.totalBhk}</td>
                  <td
                    className="px-4 py-4 text-sm cursor-pointer"
                    title={formatINR(row.baseRate)}
                  >
                    {formatINRShort(row.baseRate)}
                  </td>

                  <td
                    title={formatINR(
                      row?.saleableArea * row?.baseRate || row.basePrice
                    )}
                    className="px-4 py-4 text-sm font-medium cursor-pointer"
                  >
                    {formatINRShort(
                      row?.saleableArea * row?.baseRate || row.basePrice
                    )}
                  </td>
                  <td className="px-4 py-4">
                    <span
                      className={`px-3 py-1 text-xs rounded-full ${getStatusStyles(
                        row.unitStatus.name
                      )}`}
                    >
                      {row.unitStatus?.name}
                    </span>
                  </td>
                  {row.unitStatus?.name === "Available" ||
                  row?.unitStatus?.name === "N/A" ? (
                    <td className="px-4 py-4">
                      {row.isPlaceholder ? (
                        <button
                          onClick={() => handleAddUnit()}
                          className="p-1 px-2 bg-customGreen text-white rounded-md transition-colors flex items-center justify-center"
                          aria-label="Add unit"
                        >
                          <span className="text-sm">Add</span>
                        </button>
                      ) : (
                        <button
                          onClick={() => handleEditUnit(row)}
                          className="p-2 text-customGreen hover:bg-blue-50 rounded-md transition-colors"
                          aria-label="Edit unit"
                        >
                          <FiEdit size={20} />
                        </button>
                      )}
                    </td>
                  ) : (
                    <td
                      onClick={() => handleEditUnit(row)}
                      className="text-center flex items-center justify-center text-2xl mt-4 cursor-pointer hover:text-customGreen"
                    >
                      <FaRegEye />
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr className="text-center">
                <td colSpan={9} className="py-8 text-gray-500">
                  No units found for this tower
                </td>
              </tr>
            )}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={9} className="px-4 py-4 text-center">
                <button
                  onClick={handleAddUnit}
                  className="px-4 py-2 bg-customGreen text-white rounded-md transition-colors flex items-center mx-auto"
                >
                  <MdAddCircleOutline className="mr-2" />
                  Add New Unit
                </button>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      {/* Unit Form Slider */}
      {isSliderOpen && editingUnit && (
        <ApartmentUnitForm
          isSliderOpen={isSliderOpen}
          onHide={handleCancelUnitEdit}
          unit={editingUnit}
          totalunitFloors={totalunitFloors}
          floorOptions={getFloorOptions()}
          handleChange={handleUnitFormChange}
          handleUnitFormChange={handleUnitFormChange}
          handleSave={handleSaveUnit}
          handleCancel={handleCancelUnitEdit}
          handleFloorsChange={handleFloorsChange}
          handleFloorBhkChange={handleFloorBhkChange}
          handleApplyToAll={handleApplyToAllUnits}
          isNew={isNewUnit}
        />
      )}

      <ApartmentBulkModel
        open={showBulkModal}
        isTower={true}
        towers={towers}
        selectedFile={selectedFile}
        setSelectedFile={setSelectedFile}
        onClose={() => {
          setShowBulkModal(false);
          setSelectedFile(null);
          navigate(-1);
        }}
        setSelectedTower={setSelectedTowerValue}
        selectedTower={selectedTowerValue}
        onImport={handleBulkUploadAppartUnits}
        fileLink={"/Apartment Bulk Upload.xlsx"}
        fileName="Apartment Bulk Upload.xlsx"
        onNextTower={handleNextTower}
        onDone={handleDone}
        currentTowerIndex={currentTowerIndex}
        setCurrentTowerIndex={setCurrentTowerIndex}
        towerUploadStatus={towerUploadStatus}
        uploadedTowers={uploadedTowers}
      />

      {/* Validation Error Modal */}
      {showValidationModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
          <div className="bg-white rounded-lg p-6 max-w-md w-full">
            <h2 className="text-lg font-medium text-red-600 mb-4">
              Validation Errors
            </h2>
            <ul className="list-disc pl-5 mb-4 max-h-60 overflow-y-auto">
              {validationErrors.map((error, index) => (
                <li key={index} className="text-sm text-gray-700">
                  {error}
                </li>
              ))}
            </ul>
            <div className="flex justify-end">
              <button
                onClick={() => setShowValidationModal(false)}
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ApartmentUnitTable;
